import type {operations} from "~/types/api-types";
import {apiAuthFetcher, apiFetcher} from "~/lib/fetchers";

export type NewsSearchResponse = operations["getNews"]["responses"]["200"]["content"]["application/cz.trieu.zmrzlina2ad-v1+json"];
export type NewsSearchQuery = operations["getNews"]["parameters"]["query"]
export type NewsSearchRequest = operations["getNews"]["requestBody"]["content"]["application/json"]

export async function getNews(request: NewsSearchRequest, query: NewsSearchQuery): Promise<NewsSearchResponse> {
  return apiFetcher<NewsSearchResponse>("/public/news/search", {
    method: "POST",
    params: {
      ...query
    },
    body: {
      ...request
    }
  })
}

export type AdminNewsSearchResponse = operations["adminSearchNews"]["responses"]["200"]["content"]["application/cz.trieu.zmrzlina2ad-v1+json"];

export async function getAdminNews(request: NewsSearchRequest, query: NewsSearchQuery): Promise<AdminNewsSearchResponse> {
  return apiAuthFetcher<AdminNewsSearchResponse>("/admin/news/search", {
    method: "POST",
    params: {
      ...query
    },
    body: {
      ...request
    }
  })
}

export type AdminNewsPatchRequest = operations["patchNews"]["requestBody"]["content"]["application/json"]

export async function patchAdminNews(id: string, request: AdminNewsPatchRequest) {
  return apiAuthFetcher(`/admin/news/${id}`, {
    method: "PATCH",
    body: {
      ...request
    }
  })
}

export async function deleteAdminNews(id: string) {
  return apiAuthFetcher(`/admin/news/${id}`, {
    method: "DELETE",
  })
}

export type AdminNewsCreateRequest = operations["createNews"]["requestBody"]["content"]["application/json"]

export async function createAdminNews(request: AdminNewsCreateRequest) {
  return apiAuthFetcher("/admin/news", {
    method: "POST",
    body: {
      ...request,
    }
  })
}
